import { render, staticRenderFns } from "./fixedTab.vue?vue&type=template&id=3c969028&scoped=true"
import script from "./fixedTab.vue?vue&type=script&lang=js"
export * from "./fixedTab.vue?vue&type=script&lang=js"
import style0 from "./fixedTab.vue?vue&type=style&index=0&id=3c969028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c969028",
  null
  
)

export default component.exports